import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { CrashMonitorService } from './app/services/crash-monitor.service';

bootstrapApplication(AppComponent, appConfig).then(appRef => {
  appRef.injector.get(CrashMonitorService).initGlobalListeners();
})
  .catch((err) => console.error(err));
